import classNames from "classnames";
import React from "react";
import { useSelector } from "src/store";

export function ProgressBar({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    const { current, max } = useSelector(state => state.bookingFlow.steps);

    return <div
        className={classNames("w-full bg-gray-200 h-1", className)}
        {...props}>
        <div style={{ width: `${current / max * 100}%` }} className="h-1 bg-primary-600 transition-all duration-300" />
    </div>
}